import { createEffect } from 'effector';
import queryString from 'query-string';
import { api } from '../../../api/axiosInstance.js';

const sectors_dict = {
  construction: 'Сектор строительства',
  'oil-and-gas': 'Нефтегазовый сектор',
  'public-utilities': 'Сектор энергетики и жилищно-коммунального хозяйства',
};

export const getSectorsDataFx = createEffect().use(
  async ({ sector, search }) => {
    let url;
    switch (sector) {
      case 'products':
        url = `matrix/cert-category/?sector=${sectors_dict['public-utilities']}`;
        break;
      case 'works':
        url = 'matrix/license-registry/';
        break;
      case 'services':
        url = 'matrix/service-registry/';
        break;
      case 'projects':
        url = 'matrix/projects/';
    }
    const query =
      sector === 'products' && search.length > 0
        ? `&${search}`
        : sector !== 'products' && search.length > 0
        ? `?${search}`
        : '';

    return (await api().get(`${url}${query}`)).data;
  }
);

export const downloadSectorsDataFx = createEffect().use(
  async ({ sector, search }) => {
    const query = queryString.stringify(search);
    const file = await api().get(
      `/cert-category/export?sector=${sector}${
        query.length > 0 ? `&${query}` : ''
      }`,
      { responseType: 'blob' }
    );
    const link = document.createElement('a');
    const url = URL.createObjectURL(file.data);
    link.href = url;
    link.target = '_blank';
    link.download = name;
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
);

export const getMatrixProjectConSheetFx = createEffect().use(async (query) => {
  return (await api().get(`matrix/consolidated-sheet/?${query}`)).data;
});

export const getMatrixProjectDataFx = createEffect().use(async (id) => {
  return (await api().get(`matrix/projects/${id}`)).data;
});
